module.exports = __webpack_public_path__ + "static/media/plus-primary.010f9cb3.svg";